var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditAvatarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47425 8.6056L8.96783 3.11201L8.20192 2.3461L2.70833 7.83968V8.6056H3.47425ZM3.92329 9.68893H1.625V7.39064L7.81896 1.19668C7.92054 1.09513 8.05829 1.03809 8.20192 1.03809C8.34555 1.03809 8.4833 1.09513 8.58488 1.19668L10.1173 2.72905C10.2188 2.83063 10.2758 2.96838 10.2758 3.11201C10.2758 3.25564 10.2188 3.39339 10.1173 3.49497L3.92329 9.68893ZM1.625 10.7723H11.375V11.8556H1.625V10.7723Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAvatarIcon);
export default __webpack_public_path__ + "static/media/edit-avatar-icon.e0a98725af74957f3f1bf1a960d18db4.svg";
export { ForwardRef as ReactComponent };